import type { TimelineRow } from '@tabel/shared/agent-events/timeline';
import { memo } from 'react';
import { LABEL, T } from '../texts';
import { Spinner } from './parts';

type Row = Extract<TimelineRow, { kind: 'user' }>;

const NOTE: Readonly<Record<NonNullable<Row['note']>, string>> = {
  sent_now: T.sentNow,
  sent_after_answer: T.sentAfter,
  from_queue: T.sentAfter,
};

/**
 * Сообщение человека — справа, в рамке (мокап `.u`). Пометка: «Отправлено сразу…», «Отправлено после ответа».
 * `pending` — сообщение принято, а агент ещё не начал работу: строки с сервера ещё нет.
 */
export const UserRow = memo(function UserRow({ row, pending = false }: { row: Row; pending?: boolean }) {
  const note = row.note ? NOTE[row.note] : null;
  return (
    <div className="ml-auto flex max-w-[86%] flex-col items-end gap-1">
      <div className="rounded-card border border-line bg-subtle px-3 py-2 text-[14px] leading-[1.5] break-words whitespace-pre-wrap text-ink">
        {row.text}
      </div>
      {note && <p className="text-[12px] text-ink-2">{note}</p>}
      {pending && (
        <p className="inline-flex items-center gap-1.5 text-[12px] text-ink-2">
          <Spinner />
          {LABEL.starting}
        </p>
      )}
    </div>
  );
});
